import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create,
} from "adminApi/LaundryTaskApi/LaundryTask";
import { validateForm } from "utils/validation";
import { LaundryTaskRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddLaundryTaskForm from "./Componates/AddLaundryTaskForm";
import fields from "../json/LaundryTaskFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddLaundryTask = () => {

    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // HandleInputChange
    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        LaundryTaskRules
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryTaskRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry Task Created Successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddLaundryTaskForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Laundry Task"
            />
        </>
    );
};

export default AddLaundryTask;
